import { FC } from 'react';
import Modal from 'src/common/components/ModalDS22';
import { useMediaQueries } from 'src/common/providers/MediaQueryProvider';
import TripCartPanelCalendar from 'src/trip-cart-deprecated/components/panel/TripCartPanelCalendar';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import TripCartPanelPriceDetails from 'src/trip-cart-deprecated/components/panel/TripCartPanelPriceDetails';
import { TRIP_CART_PANEL_CALENDAR, TRIP_CART_PANEL_PRICE_DETAILS } from 'src/listing/constants';
import PanelNavigation from 'src/common/components/dockyard/PanelNavigation';
import styles from './TripCartAsidePanel.module.scss';

const CLOSE_TIMEOUT_MS = 350;

const TripCartAsidePanel: FC = () => {
  const {
    isOpen, setOpen, activePanel, panelDirection,
  } = useTripCartContext();
  const { l: isLargeScreen } = useMediaQueries();

  if (!isLargeScreen) return null;

  return (
    <Modal
      label="Trip Cart Calendar"
      modalOpen={isOpen}
      closeModal={() => setOpen(false)}
      position="right"
      size="medium"
      closeTimeoutMS={CLOSE_TIMEOUT_MS}
    >
      <div className={styles.content}>
        <PanelNavigation
          id={activePanel}
          direction={panelDirection}
        >
          {() => (
            <>
              {activePanel === TRIP_CART_PANEL_CALENDAR && (
                <TripCartPanelCalendar />
              )}
              {activePanel === TRIP_CART_PANEL_PRICE_DETAILS && (
                <TripCartPanelPriceDetails />
              )}
            </>
          )}
        </PanelNavigation>
      </div>
    </Modal>
  );
};

export default TripCartAsidePanel;
